document.addEventListener('click', function(e) {
  'use strict';
  const link = e.target.closest('[data-beneficial-ownership-view]');
  if (!link || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;

  e.preventDefault();

  const sectionUrl = new URL(link.href);
  sectionUrl.searchParams.set('section', '13dg');

  fetch(sectionUrl)
    .then(function(response) {
      if (!response.ok) throw new Error(response.statusText);
      return response.text();
    })
    .then(function(html) {
      const section = new DOMParser()
        .parseFromString(html, 'text/html')
        .getElementById('beneficial-ownership');
      if (!section) throw new Error('missing #beneficial-ownership');

      document.getElementById('beneficial-ownership').replaceWith(section);
      history.replaceState(null, '', link.href);
    })
    .catch(function() {
      window.location.href = link.href;
    });
});
